import { Maybe, If, Operation } from './globalTypes'

import { BannerFragment, bannerFragmentString } from './BannerFragment'

import {
  RibbonStoriesFragment,
  ribbonStoriesFragmentString,
} from './RibbonStoriesFragment'

import {
  BentoSectionFragment,
  bentoSectionFragmentString,
} from './BentoSectionFragment'

import {
  VideoBlockFragment,
  videoBlockFragmentString,
} from './VideoBlockFragment'

import { gridTypeString } from './GridType'

import { bentoCardFragmentString } from './BentoCardFragment'

import { contentPopFragmentString } from './ContentPopFragment'

import { slideTypeString } from './SlideType'

import { cardTypeSectionFragmentString } from './CardTypeSectionFragment'

import { imageDiffFragmentString } from './ImageDiffFragment'

import { productPopFragmentString } from './ProductPopFragment'

import getHomePageRawString from '../GetHomePage.graphql'

const getHomePageString = [
  getHomePageRawString,
  bannerFragmentString,
  ribbonStoriesFragmentString,
  bentoSectionFragmentString,
  videoBlockFragmentString,
  gridTypeString,
  bentoCardFragmentString,
  contentPopFragmentString,
  slideTypeString,
  cardTypeSectionFragmentString,
  imageDiffFragmentString,
  productPopFragmentString,
].join('\n\n')

export type GetHomePageData = {
  homepage: Maybe<{
    sections: Maybe<
      Maybe<
        | If<'ComponentSectionsBannerSlider', BannerFragment>
        | If<'ComponentSectionsRibbonStories', RibbonStoriesFragment>
        | If<'ComponentSectionsBentoSections', BentoSectionFragment>
        | If<'ComponentSectionsVideoBlocks', VideoBlockFragment>
        | If<
            | 'ComponentSectionsBentoGridSection'
            | 'ComponentSectionsCardType'
            | 'Error',
            {}
          >
      >[]
    >
  }>
}

export type GetHomePage = Operation<GetHomePageData>

export const GetHomePage = (): GetHomePage => ({
  query: getHomePageString,
  variables: undefined,
})
